export const PERSONA_DEAL_MAKER = 'Dealmaker';
export const PERSONA_SHOPPER = 'Shopper';
export const PERSONA_DEALER = 'Dealer';
export const PERSONA_SYSTEM = 'System';
